import React, { useState } from "react";
import Lottie from "react-lottie-player";
import { useUploadedFiles } from "../../store/UploadedFileProvider";
import { BoxWithShadow } from "../../components/containers/styledComponents";
import { IconContainer } from "../../components/visuals/styledComponents";
import { RowContainer } from "../../components/containers/styledComponents";
import { CompassParagraph } from "../../components/common/styledComponents";
import { RunJobModal } from "./RunJobModal";
import {
  CompassGreenButton,
  CompassWhiteButton,
} from "../../components/buttons/styledComponents";
import { compassDarBlue, compassLightBlue } from "../../styles";
import checkMarkAnimation from "../../assets/lottie/success_checkmark_animation.json";
import { FileOptionTabTitle } from "../../types/fileUploadTypes";
import { ValidationResponse } from "../../types/validationTypes";

export const SuccessFulUploadBox = ({
  fileType,
  onValidationFailed,
}: SuccessFulUploadBoxProps): JSX.Element => {
  const { uploadedFiles, deleteFile } = useUploadedFiles();
  const [showRunJobModal, setShowRunJobModal] = useState<boolean>(false);

  const handleValidationFailed = (response: ValidationResponse): void => {
    setShowRunJobModal(false);
    onValidationFailed(response);
  };

  return (
    <>
      <BoxWithShadow>
        <IconContainer size={90}>
          <Lottie
            loop={false}
            animationData={checkMarkAnimation}
            play
            style={{ width: "100%", height: "100%" }}
          />
        </IconContainer>
        <RowContainer jc="center">
          <CompassParagraph
            fontSize={17}
            bold={true}
            color={compassDarBlue}
            mt={-15}
          >
            File Uploaded Successfully!
          </CompassParagraph>
        </RowContainer>
        <RowContainer jc="center">
          <CompassParagraph color={compassLightBlue} underline={true} mr={5}>
            {uploadedFiles[fileType].file?.name}
          </CompassParagraph>
          <CompassParagraph fontSize={13} color={compassDarBlue}>
            is ready for processing.
          </CompassParagraph>
        </RowContainer>
        <RowContainer jc="center">
          <CompassWhiteButton
            size="s"
            onClick={(): void => deleteFile(fileType)}
          >
            Delete File
          </CompassWhiteButton>
          <CompassGreenButton onClick={(): void => setShowRunJobModal(true)}>
            <CompassParagraph mr={1} fontSize={14}>
              Continue
            </CompassParagraph>
          </CompassGreenButton>
        </RowContainer>
      </BoxWithShadow>
      <RunJobModal
        show={showRunJobModal}
        handleClose={(): void => setShowRunJobModal(false)}
        onValidationFailed={handleValidationFailed}
      />
    </>
  );
};

type SuccessFulUploadBoxProps = {
  fileType: FileOptionTabTitle;
  onValidationFailed: (response: ValidationResponse) => void;
};
